/**
 * Created by Ning Jiang on 2021-05-04.
 */

import {IWinRatioConfig} from "../core/config/WinRatio";
import {BetWinMode} from "../core/config/BetWinMode";
import {IReelSets} from "../core/reel/reelset/ReelSet";
import {StackedSymbol} from "../core/reel/stackedsymbol/StackedSymbol";


export class KarenGameConfig {

    // Game basic
    public static BET_WIN_MODE: BetWinMode = BetWinMode.BET_WAY;
    public static IS_FEATURE_BUY:boolean = false;

    // Reels
    public static REELS_NUM: number = 6;
    public static SYM_WIDTH: number = 120;
    public static SYM_HEIGHT: number[] = [210, 84, 84, 84, 84, 84];

    // Win
    public static WIN_RATIOS: IWinRatioConfig[] = [
        {
            ratio: 0,
            name: "Tiny Win",
            duration: 0,
            bigWinLevel: -1,
            winRatioIndex:0
        },
        {
            ratio: 1.5,
            name: "Small Win",
            duration: 0,
            bigWinLevel: -1,
            winRatioIndex:1
        },
        {
            ratio: 3,
            name: "Medium Win",
            duration: 0.4,
            bigWinLevel: -1,
            winRatioIndex:2
        },
        {
            ratio: 5,
            name: "Large Win",
            duration: 0.8,
            bigWinLevel: -1,
            winRatioIndex:3
        },
        {
            ratio: 15,
            name: "Big Win 1",
            duration: 3.663,
            bigWinLevel: 0,
            winRatioIndex:3
        },
        {
            ratio: 25,
            name: "Big Win 2",
            duration: 3.663,
            bigWinLevel: 1,
            winRatioIndex:3

        },
        {
            ratio: 50,
            name: "Big Win 3",
            duration: 3.663,
            bigWinLevel: 2,
            winRatioIndex:3
        },
        {
            ratio: 250,
            name: "Big Win 4",
            duration: 7.357,
            bigWinLevel: 3,
            winRatioIndex:3
        }
    ];

    public static REEL_SETS: IReelSets = {
        "BASE_REELSET": [
            ["M1", "L1", "L3", "XW2", "M2", "L2", "M4", "L5", "M3", "L4", "M5"],
            ["M1", "L1", "L3", "M2", "L2", "XW", "M4", "L5", "M3", "L4", "M5"],
            ["M1", "L1", "L3", "M2", "L2", "XW", "M4", "L5", "M3", "L4", "M5"],
            ["M1", "L1", "L3", "M2", "L2", "M4", "L5", "M3", "L4", "M5"],
            ["M1", "L1", "L3", "M2", "L2", "M4", "L5", "M3", "L4", "M5"],
            ["M1", "L1", "L3", "M2", "L2", "M4", "L5","W","M1", "M3", "L4", "M5","M2","L2","L5"]
        ],
        "FEATURE_REELS": [
            ["M1", "L1", "L3", "XW2", "M2", "L2", "M4", "L5", "M3", "L4", "M5"],
            ["M1", "L1", "L3", "M2", "L2", "XW", "M4", "L5", "M3", "L4", "M5"],
            ["M1", "L1", "L3", "M2", "L2", "XW", "M4", "L5", "M3", "L4", "M5"],
            ["M1", "L1", "L3", "M2", "L2", "M4", "L5", "M3", "L4", "M5"],
            ["M1", "L1", "L3", "M2", "L2", "M4", "L5", "M3", "L4", "M5"],
            ["M1", "W", "L1", "L3", "M2", "L2", "M4", "L5", "M3", "W", "L4", "M5"]
        ],
        "FREESPIN_REELSET": [
            ["M1", "L1", "L3", "L3", "M2", "L2", "M4", "L5", "M3", "L4", "M5"],
            ["M1", "L1", "L3", "M2", "L2", "M5", "M4", "L5", "M3", "L4", "M5"],
            ["M1", "L1", "L3", "M2", "L2", "M5", "M4", "L5", "M3", "L4", "M5"],
            ["M1", "L1", "L3", "M2", "L2", "M4", "L5", "M3", "L4", "M5"],
            ["M1", "L1", "L3", "M2", "L2", "M4", "L5", "M3", "L4", "M5"],
            ["M1", "W", "L1", "L3", "M2", "L2", "M4", "L5", "M3", "W", "L4", "M5"]
        ]
    };

    public static updateReelSets(): void {
        // Filter stacked symbols on REEL_SETS if any.
        for (let reelSetKey in this.REEL_SETS) {
            this.REEL_SETS[reelSetKey].forEach((reelSet: string[], reelId: number) => {
                this.REEL_SETS[reelSetKey][reelId] = StackedSymbol.filterStackedSymbolsReelSet(reelSet, reelId);
            });
        }
    }
}